import { defineComponent as _defineComponent } from 'vue';
import EnBadge from 'Components/base/EnBadge/EnBadge.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnBetaBadge',
    props: {
        staticId: {
            type: [String, Number],
            default: null,
        },
        /** Renders the badge in the text flow (e.g. next to a label) instead of pinned to the parent's top right corner. */
        inline: {
            type: Boolean,
            default: false,
        },
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const __returned__ = { EnBadge };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
